/* eslint-disable */
import * as Types from './types';

import { SellingPlanFragmentDoc } from './SellingPlanFragment';
import { MoneyFragmentDoc } from './MoneyFragment';
export type SellingPlanGroupsFragment = { __typename?: 'SellingPlanGroup', appName?: string | null, name: string, sellingPlans: { __typename?: 'SellingPlanConnection', edges: Array<{ __typename?: 'SellingPlanEdge', node: { __typename?: 'SellingPlan', id: string, description?: string | null, name: string, recurringDeliveries: boolean, options: Array<{ __typename?: 'SellingPlanOption', name?: string | null, value?: string | null }>, priceAdjustments: Array<{ __typename?: 'SellingPlanPriceAdjustment', orderCount?: number | null, adjustmentValue: { __typename?: 'SellingPlanFixedAmountPriceAdjustment', adjustmentAmount: { __typename?: 'MoneyV2', currencyCode: Types.CurrencyCode, amount: string } } | { __typename?: 'SellingPlanFixedPriceAdjustment', price: { __typename?: 'MoneyV2', currencyCode: Types.CurrencyCode, amount: string } } | { __typename?: 'SellingPlanPercentagePriceAdjustment', adjustmentPercentage: number } }> } }> }, options: Array<{ __typename?: 'SellingPlanGroupOption', name: string, values: Array<string> }> };

export declare const SellingPlanGroupsFragment: import("graphql").DocumentNode;
export const SellingPlanGroupsFragmentDoc = /*#__PURE__*/ `
    fragment SellingPlanGroupsFragment on SellingPlanGroup {
  sellingPlans(first: $numProductSellingPlans) {
    edges {
      node {
        ...SellingPlanFragment
      }
    }
  }
  appName
  name
  options {
    name
    values
  }
}
    `;